import React from "react";

const Section3 = () => {
  return (
    <>
      <div className="flex w-[95%] lg:w-[85%] xl:w-[60%] justify-between items-center m-auto     ">
        <div className="hidden lg:block lg:w-[45%]">
          <img src="../../../assets/mbg-banner2.webp" alt="" />
        </div>
        <div className="flex flex-col gap-6 w-full items-center lg:items-start lg:w-[45%]">
          <h1 className="text-3xl font-bold uppercase text-center lg:text-start text-red-600 ">
            Money Back Guarantee
          </h1>
          <div className="w-[40%] h-[8px]  bg-gray-800"></div>
          <p className="text-lg text-gray-700 text-center lg:text-start">
            Money Back Guarantee is a highly anticipated Pakistani film, written
            and directed by Faisal Qureshi, starring the biggest starts of all
            time Wasim Akram, Fawad Khan, Gohar Rasheed, Ayesha Omer, Mikaal
            Zulfiqar, Jan Rambo, Hina Dilpazir, Shayan Khan, and Kiran Malik.
            Produced by Zashko Films. The film premiered on 21st April 2023
            worldwide.
          </p>
        </div>
      </div>

      <div className="w-[70%] lg:w-[50%] h-[4px] bg-gray-300 mt-10 mb-10 m-auto"></div>
    </>
  );
};

export default Section3;
